import i18n from 'i18next';

const invoiceDescription = (hasAccessToInvoices, isGlobalSearch) => {
  const hasAccess = hasAccessToInvoices;
  let description = {};

  if (!hasAccess) {
    description = {
      titleText: i18n.t('invoices:NoAccess'),
    };
  } else if (isGlobalSearch) {
    description = {
      titleText: i18n.t('invoices:NoResults'),
      subText: i18n.t('invoices:NoResultsBody'),
    };
  } else if (!isGlobalSearch) {
    description = {
      titleText: i18n.t('invoices:NoInvoices'),
    };
  }

  return description;
};

export default invoiceDescription;



// WEBPACK FOOTER //
// ./src/containers/Invoices/InvoicesList/invoice-description.js